import type { ReactNode } from "react";
import { CircleHelp } from "lucide-react";
import { helpForScreen } from "../app/help";

export function PageHeader({ title, subtitle, screenId, actions }: { title: string; subtitle?: ReactNode; screenId?: string; actions?: ReactNode }) {
  return (
    <header className="page-header">
      <div>
        <h1>{title}</h1>
        {subtitle && <p className="subtitle">{subtitle}</p>}
      </div>
      <div className="page-actions">
        {actions}
        {screenId && (
          <a href={helpForScreen(screenId)} target="_blank" rel="noopener" className="button ghost" aria-label={`Help for ${title} (opens the help center)`}>
            <CircleHelp size={16} aria-hidden /> Help
          </a>
        )}
      </div>
    </header>
  );
}
